import { Autocomplete, Box, CircularProgress, Link, Tab, Tabs, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSite } from "../../context/siteContext";
import customHttp from "../../services/customHTTP";
import Datagrid from "../Datagrid/Datagrid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { ASSETS_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const ManageChangeParts = () => {
	const [selectedMachine, setSelectedMachine] = useState(null);
	const [machineProducts, setMachineProducts] = useState([]);
	const [machineChangeProducts, setMachineChangeProducts] = useState([]);
	const [siteProducts, setSiteProducts] = useState([]);
	const [machines, setMachines] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [selectedCpRows, setSelectedCpRows] = useState([]);
	const [partsLoading, setPartsLoading] = useState(true);
	const [error, setError] = useState("");
	const { selectedSite } = useSite();
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	useEffect(() => {
		const fetchProducts = async () => {
			try {
				const req_body = {
					site_number: selectedSite,
				};
				const response = await customHttp.post("/products/bysiteid", req_body);
				if (response.status === 200) {
					setSiteProducts(response.data.data);
					console.log(response);
				}
			} catch (error) {
				console.error("Error fetching products:", error);
			}
		};
		const fetchMachines = async () => {
			try {
				const reqBody = {
					site_number: selectedSite,
				};

				const response = await customHttp.post("/machines/bysiteid", reqBody);
				if (response.data.success) {
					setMachines(response.data.data); // Set the filtered machines array
					console.log(response.data.data);
				} else {
					setError("Failed to fetch data: No success flag.");
				}
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setPartsLoading(false);
			}
		};

		fetchProducts();
		fetchMachines();
	}, []);

	const handleShowParts = async (machine) => {
		console.log("Machine Id: ", machine);
		// Filter products with meta_key === "change_part" and status === true
		const changeParts = siteProducts.filter((part) => {
			return (
				part.machine_id === machine.machine_id &&
				part.product_meta.some((meta) => {
					if (meta.meta_key === "change_part") {
						const metaValue = JSON.parse(meta.meta_value);
						return metaValue.status === true;
					}
					return false;
				})
			);
		});

		// Filter products that are NOT "change_part"
		const nonChangeParts = siteProducts.filter((part) => {
			return (
				part.machine_id === machine.machine_id &&
				!part.product_meta.some((meta) => {
					return meta.meta_key === "change_part";
				})
			);
		});

		console.log(nonChangeParts);
		console.log(changeParts);
		setMachineProducts(nonChangeParts);
		setMachineChangeProducts(changeParts);
	};

	const handleMarkChangeParts = async () => {
		console.log(selectedRows);
		const req_body = {
			products: selectedRows,
			selectedMachine,
		};
		try {
			const response = await customHttp.post("/products/mark_as_change_parts", req_body);
			if (response.data.status) {
				Swal.fire({
					icon: "success",
					title: "Success",
					text: "Part(s) marked as Change Parts",
				});
				setMachineProducts((prevProducts) =>
					prevProducts.filter((row) => !selectedRows.includes(row.product_id))
				);

				setMachineChangeProducts((prevChangeProducts) => [
					...prevChangeProducts,
					...machineProducts.filter((row) => selectedRows.includes(row.product_id)),
				]);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleRemoveChangeParts = async () => {
		console.log(selectedCpRows);
		const req_body = {
			products: selectedCpRows,
		};
		try {
			const response = await customHttp.post("/products/remove_as_change_parts", req_body);
			if (response.data.status) {
				Swal.fire({
					icon: "success",
					title: "Success",
					text: "Part(s) Unmarked as Change Parts",
				});
				setMachineChangeProducts((prevProducts) =>
					prevProducts.filter((row) => !selectedCpRows.includes(row.product_id))
				);

				setMachineProducts((prevChangeProducts) => [
					...prevChangeProducts,
					...machineChangeProducts.filter((row) => selectedCpRows.includes(row.product_id)),
				]);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handlePartsSelect = (rows) => {
		setSelectedRows(rows);
	};

	const handleChangePartsSelect = (rows) => {
		setSelectedCpRows(rows);
	};

	const columns = [
		{
			field: "product_name",
			headerName: "Part Name",
			flex: 1,
			renderCell: (params) => {
				const defaultImage = `${ASSETS_BASE_URL}/stock.png`;

				const handleError = (e) => {
					e.target.onerror = null; // Prevent infinite loop
					e.target.src = defaultImage; // Fallback to default image
				};

				const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${params.row.product_number}.png`;

				return (
					<div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-start" }}>
						<img
							src={src}
							alt={params.row.product_name}
							onError={handleError}
							style={{
								width: "40px",
								height: "40px",
								objectFit: "cover",
								borderRadius: "4px",
							}}
						/>
						<div>
							<Link
								sx={{ cursor: "pointer" }}
								variant="body2"
								onClick={() => {
									navigate(`/machines/${params.row.machine_id}/${params.row.product_id}`);
								}}>
								{params.row.product_name}
							</Link>
						</div>
					</div>
				);
			},
		},
		{ field: "product_number", headerName: "Part #", width: 200 },
	];

	const customButtons = [
		{
			label: "Mark Change Parts",
			icon: <CheckCircleIcon />,
			onClick: () => {
				handleMarkChangeParts();
			},
		},
	];

	const customButtonsCp = [
		{
			label: "Unmark Change Parts",
			icon: <RadioButtonUncheckedIcon />,
			onClick: () => {
				handleRemoveChangeParts();
			},
		},
	];

	if (partsLoading) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					height: "400px",
					width: "100%",
					mt: 2,
					p: 1,
				}}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "flex-start",
				alignItems: "flex-start",
				height: "100%",
				width: "100%",
				mt: 2,
				py: 2,
			}}>
			<Box sx={{ width: "30%" }}>
				<Autocomplete
					options={machines}
					key={(option) => option.machine_id}
					getOptionLabel={(option) => `${option.machine_number} - ${option.machine_name}`}
					value={selectedMachine}
					onChange={(event, newValue) => {
						setSelectedMachine(newValue);
						if (newValue) {
							handleShowParts(newValue);
						} else {
							setMachineChangeProducts([]);
							setMachineProducts([]);
							setSelectedMachine(null); // Clear selected site when customer is cleared
						}
					}}
					renderInput={(params) => <TextField {...params} label="Select a Machine" variant="outlined" />}
					fullWidth
					size="small"
				/>
			</Box>
			{selectedMachine && (
				<Box sx={{ width: "100%" }}>
					{/* Tabs for Machine Parts and Change Parts */}
					<Tabs value={activeTab} onChange={handleTabChange} aria-label="machine parts tabs">
						<Tab label="Machine Parts" />
						<Tab label="Change Parts" />
					</Tabs>

					{/* Machine Parts Tab Content */}
					{activeTab === 0 && (
						<Datagrid
							loading={partsLoading}
							data={machineProducts}
							columns={columns}
							customButtons={customButtons}
							checkboxSelection={true}
							rowIdField="product_id"
							onSelect={handlePartsSelect}
							sortBy={[{ field: "product_number", sort: "asc" }]}
						/>
					)}

					{/* Change Parts Tab Content */}
					{activeTab === 1 && (
						<Datagrid
							loading={partsLoading}
							data={machineChangeProducts}
							columns={columns}
							customButtons={customButtonsCp}
							checkboxSelection={true}
							rowIdField="product_id"
							onSelect={handleChangePartsSelect}
							noDataText="No Change Part(s) Found"
							sortBy={[{ field: "product_number", sort: "asc" }]}
						/>
					)}
				</Box>
			)}
		</Box>
	);
};

export default ManageChangeParts;
